import React from 'react';
import { useApp } from 'providers';
import { AuthPageInfo, DepositSidebar, RegistrationForm } from 'components';
import { useErrorParam, usePageTracking } from 'hooks';
import { Tracking, TRACKING_PAGES } from 'api';
import './Deposit.scss';

export const RegistrationPage: React.FC = () => {
  const { user } = useApp();
  const error = useErrorParam(false);
  if (error) {
    Tracking.setPageError();
    Tracking.setContext({
      '41': '[erreurImmat]',
      '38': user?.isPro ? '[pro_etape_0_immat_erreur]' : '[etape_0_immat_erreur]',
    });
  }

  usePageTracking(user!.isPro ? TRACKING_PAGES.IMMAT_PRO : TRACKING_PAGES.IMMAT_PART);

  return (
    <>
      <div className="container-left">
        <RegistrationForm isPro={user!.isPro} customerReference={user!.username} defaultErrorMessage={error?.message} />
      </div>
      <div className="container-right">
        {!user?.isPro && <AuthPageInfo />}
        {user?.isPro && <DepositSidebar />}
      </div>
    </>
  );
};
